module.exports = __webpack_public_path__ + "img/Indonesia-5-hover.ab27008c.jpg";